<div class="container" matomoForm="view-request-to-pay">
  <mat-grid-list cols="2" rowHeight="350">
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card
        class="mat-elevation-z8"
        *ngIf="datasource.transactionRequest"
        matomoClick="view-request-payer-info-card"
        (click)="onPayerInfoView()"
      >
        <mat-card-title>Payer</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="
                datasource.transactionRequest.payerPartyIdType !== undefined
              "
            >
              Id Type
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="
                datasource.transactionRequest.payerPartyIdType !== undefined
              "
            >
              {{ datasource.transactionRequest.payerPartyIdType }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payerPartyId !== undefined"
            >
              Id
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payerPartyId !== undefined"
            >
              {{ datasource.transactionRequest.payerPartyId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payerDfspId !== undefined"
            >
              DFSP Id
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payerDfspId !== undefined"
            >
              {{ datasource.transactionRequest.payerDfspId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payerDfspId !== undefined"
            >
              DFSP Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payerDfspId !== undefined"
            >
              {{
                displayDfspName(
                  getDfpsEntry(datasource.transactionRequest.payerDfspId)
                )
              }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="
                datasource.transactionRequest.payerDateOfBirth !== undefined
              "
            >
              Date of Birth
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="
                datasource.transactionRequest.payerDateOfBirth !== undefined
              "
            >
              {{ datasource.transactionRequest.payerDateOfBirth }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payerLastName !== undefined"
            >
              Last Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payerLastName !== undefined"
            >
              {{ datasource.transactionRequest.payerLastName }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payerFirstName !== undefined"
            >
              First Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payerFirstName !== undefined"
            >
              {{ datasource.transactionRequest.payerFirstName }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card
        class="mat-elevation-z8"
        *ngIf="datasource.transactionRequest"
        matomoClick="view-request-payee-info-card"
        (click)="onPayeeInfoView()"
      >
        <mat-card-title>Payee</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="
                datasource.transactionRequest.payeePartyIdType !== undefined
              "
            >
              Id Type
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="
                datasource.transactionRequest.payeePartyIdType !== undefined
              "
            >
              {{ datasource.transactionRequest.payeePartyIdType }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payeePartyId !== undefined"
            >
              Id
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payeePartyId !== undefined"
            >
              {{ datasource.transactionRequest.payeePartyId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payeeDfspId !== undefined"
            >
              DFSP Id
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payeeDfspId !== undefined"
            >
              {{ datasource.transactionRequest.payeeDfspId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payeeDfspId !== undefined"
            >
              DFSP Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payeeDfspId !== undefined"
            >
              {{
                displayDfspName(
                  getDfpsEntry(datasource.transactionRequest.payeeDfspId)
                )
              }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="
                datasource.transactionRequest.payeeDateOfBirth !== undefined
              "
            >
              Date of Birth
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="
                datasource.transactionRequest.payeeDateOfBirth !== undefined
              "
            >
              {{ datasource.transactionRequest.payeeDateOfBirth }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payeeLastName !== undefined"
            >
              Last Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payeeLastName !== undefined"
            >
              {{ datasource.transactionRequest.payeeLastName }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payeeFirstName !== undefined"
            >
              First Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payeeFirstName !== undefined"
            >
              {{ datasource.transactionRequest.payeeFirstName }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list cols="2" rowHeight="450">
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card
        class="mat-elevation-z8"
        *ngIf="datasource.transactionRequest"
        matomoClick="view-request-transfer-info-card"
        (click)="onTransferInfoView()"
      >
        <mat-card-title>Transfer</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.transactionId !== undefined"
            >
              Transfer Code
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.transactionId !== undefined"
            >
              {{ datasource.transactionRequest.transactionId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.amount !== undefined"
            >
              Transfer Amount
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.amount !== undefined"
            >
              {{ datasource.transactionRequest.amount }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.currency !== undefined"
            >
              Transfer Currency
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.currency !== undefined"
            >
              {{ datasource.transactionRequest.currency }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.feeType !== undefined"
            >
              Fee Type
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.feeType !== undefined"
            >
              {{ datasource.transactionRequest.feeType }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.completedAt !== undefined"
            >
              Transfer Completed
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.completedAt !== undefined"
            >
              {{ formatDate(datasource.transactionRequest.completedAt) }}
            </div>
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.completedAt !== undefined"
            >
              Transfer Status
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.state !== undefined"
              [ngClass]="{
                red: datasource.transactionRequest.state === 'FAILED',
                green: datasource.transactionRequest.state === 'ACCEPTED',
                orange: datasource.transactionRequest.state === 'IN_PROGRESS'
              }"
            >
              {{ datasource.transactionRequest.state }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card
        class="mat-elevation-z8"
        *ngIf="datasource.transactionRequest"
        matomoClick="view-request-fees-info-card"
        (click)="onFeesInfoView()"
      >
        <mat-card-title>Fees</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payerQuoteCode !== undefined"
            >
              Payer quote code
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payerQuoteCode !== undefined"
            >
              {{ datasource.transactionRequest.payerQuoteCode }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payerFee !== undefined"
            >
              Payer fee
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payerFee !== undefined"
            >
              {{ datasource.transactionRequest.payerFee }}
              {{ datasource.transactionRequest.payerFeeCurrency }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payeeQuoteCode !== undefined"
            >
              Payee quote code
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payeeQuoteCode !== undefined"
            >
              {{ datasource.transactionRequest.payeeQuoteCode }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transactionRequest.payeeFee !== undefined"
            >
              Payee fee
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transactionRequest.payeeFee !== undefined"
            >
              {{ datasource.transactionRequest.payeeFee }}
              {{ datasource.transactionRequest.payeeFeeCurrency }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

<div
  class="mat-elevation-z8 container"
  matomoClick="view-request-task-list-container"
  (click)="onTaskListView()"
>
  <table mat-table [dataSource]="taskList" multiTemplateDataRows matSort>
    <ng-container matColumnDef="payment-task-list">
      <th mat-header-cell *matHeaderCellDef colspan="4">
        Transaction Task List
      </th>
    </ng-container>

    <ng-container matColumnDef="payment-process-id">
      <th mat-header-cell *matHeaderCellDef>Payment Process Id</th>
    </ng-container>

    <ng-container matColumnDef="payment-process-id-value">
      <th mat-header-cell *matHeaderCellDef colspan="3">
        {{ getPaymentProcessId() }}
      </th>
    </ng-container>

    <ng-container matColumnDef="timestamp">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="view-request-sort-timestamp"
        (click)="onTableSort('timestamp', 'Task List')"
      >
        Time (UTC)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ formatDate(convertTimestampToDate(transaction.timestamp)) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="elementId">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="view-request-sort-element-id"
        (click)="onTableSort('elementId', 'Task List')"
      >
        Task Id
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.elementId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="view-request-sort-task-type"
        (click)="onTableSort('type', 'Task List')"
      >
        Task Type
      </th>
      <td mat-cell *matCellDef="let transaction">{{ transaction.type }}</td>
    </ng-container>

    <ng-container matColumnDef="intent">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="view-request-sort-status"
        (click)="onTableSort('intent', 'Task List')"
      >
        Status
      </th>
      <td
        mat-cell
        *matCellDef="let transaction"
        [ngClass]="{
          orange: transaction.intent === 'CREATED',
          blue: transaction.intent === 'ACTIVATED',
          green: transaction.intent === 'COMPLETED'
        }"
      >
        {{ transaction.intent }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let transaction">
        <button
          mat-button
          color="grey"
          matomoClick="view-request-expand-task-row"
        >
          <span *ngIf="!checkExpanded(transaction)">
            <fa-icon icon="angle-down"></fa-icon>&nbsp;&nbsp;
          </span>
          <span *ngIf="checkExpanded(transaction)">
            <fa-icon icon="angle-up"></fa-icon>&nbsp;&nbsp;
          </span>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let transaction"
        [attr.colspan]="displayedColumns.length"
      >
        <div
          class="transaction-detail"
          [@detailExpand]="
            checkExpanded(transaction) ? 'expanded' : 'collapsed'
          "
        >
          <table mat-table [dataSource]="transaction.datasource" matSort>
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Time (UTC)
              </th>
              <td mat-cell *matCellDef="let transaction">
                {{ formatDate(convertTimestampToDate(transaction.timestamp)) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="elementId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Id</th>
              <td mat-cell *matCellDef="let transaction">
                {{ transaction.elementId }}
              </td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Task Type
              </th>
              <td mat-cell *matCellDef="let transaction">
                {{ transaction.type }}
              </td>
            </ng-container>

            <ng-container matColumnDef="intent">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td
                mat-cell
                *matCellDef="let transaction"
                [ngClass]="{
                  orange: transaction.intent === 'CREATED',
                  blue: transaction.intent === 'ACTIVATED',
                  green: transaction.intent === 'COMPLETED'
                }"
              >
                {{ transaction.intent }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumnsDetailsTable"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumnsDetailsTable"
            ></tr>
          </table>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['payment-task-list']"></tr>
    <tr
      mat-header-row
      *matHeaderRowDef="['payment-process-id', 'payment-process-id-value']"
    ></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let transaction; columns: displayedColumns"
      class="transaction-row"
      [class.transaction-expanded-row]="checkExpanded(transaction)"
      (click)="pushPopElement(transaction)"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="transaction-detail-row"
    ></tr>
  </table>
</div>

<div
  class="mat-elevation-z8 container marginTop100"
  matomoClick="view-request-business-attributes-container"
  (click)="onBusinessAttributesView()"
>
  <table mat-table [dataSource]="businessAttributes" matSort>
    <ng-container matColumnDef="payment-business-attributes">
      <th mat-header-cell *matHeaderCellDef colspan="3">
        Transaction Business Attributes
      </th>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="view-request-sort-attribute-name"
        (click)="onTableSort('name', 'Business Attributes')"
      >
        Name
      </th>
      <td mat-cell *matCellDef="let transaction">{{ transaction.name }}</td>
    </ng-container>

    <ng-container matColumnDef="timestamp">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="view-request-sort-attribute-timestamp"
        (click)="onTableSort('timestamp', 'Business Attributes')"
      >
        Time (UTC)
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ formatDate(convertTimestampToDate(transaction.timestamp)) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="view-request-sort-attribute-value"
        (click)="onTableSort('value', 'Business Attributes')"
      >
        Value
      </th>
      <td
        mat-cell
        *matCellDef="let transaction"
        [innerHTML]="transaction.value | prettyPrint"
      ></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['payment-business-attributes']"></tr>
    <tr
      mat-header-row
      *matHeaderRowDef="displayedBusinessAttributeColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedBusinessAttributeColumns"
    ></tr>
  </table>
</div>
